import { createSelector } from "@reduxjs/toolkit";

export const getCategories = createSelector(
  (state) => state.categories.list,
  (list) => list
)
